// extracted by mini-css-extract-plugin
export default {"stat-card":"UpdateForPublicTreasury_stat-card__XO9wW","stats-container":"UpdateForPublicTreasury_stats-container__tA1Hu"};